import { Color, Date, Email, IComment, ID, IPost, Phone, URL, VIDEO_HOSTING_TYPE } from "@libs/interfaces/layouts"
import { IUser } from "src/settings/zustand"


export interface IPartner extends IPost {
    link?: string
    order?:number
}

export interface IPlace extends IPost {
    coordinates: number[]
    events?: IEvent[]
    url: URL
    images: URL[]
    data: any,
    type: ID[]
    placeTypes: IPlaceType[],
    onClick?: (evt:any, coords: number[], data: any) => void
}
export interface IPlaceType extends IPost {
    color: Color
    icon: string
}
export interface IEvent extends IPost { 
    places: IPlace[] 
    commands: ITeam[]
    url?: URL
    coordinates?: number[]
    logo?: string
    thumbnail?: URL
    images: URL[]
    images_names?: string[]
    email: Email[]
    phone: Phone[]
    type: ID[]
    eventTypes: IEventType[],
    start: string
    finish: string
}
export interface IEventType extends IPost {
    color: Color
    icon: string
    module?: string
}
export interface ITeam extends IPost {
    places: IPlace[]
    users: IUser[]
    core: IUser[]
    url: URL
    type: ID[]
    teamTypes: ITeamType[]
    coordinates?: number[]
}
export interface ITeamType extends IPost {
    color: Color
    icon: string
}
export interface INews extends IPost { 
    date: Date
    url: URL 
    images: URL[]
    tags: IPost[]
    address: string
}
export interface IGoods extends IPost { 
    date: Date
    url: URL 
    undertitle: string
    producer?: string
    images: URL[]
    tags: IPost[]
    address?: string
    price?: number
}
export interface IVideo extends IPost { 
    link: URL 
    type: VIDEO_HOSTING_TYPE
    date?: Date
    images?: URL[]
    tags?: IPost[]
}
export interface IAds extends IPost { 
    date: Date
    url: URL 
    images: URL[]
    priority: number
    order?: number
    parent?: IPost,
    parent_id?: ID
    parent_type?: string 
}

export enum MAP_FILTER {
    PLACES = "PLACES",
    EVENTS = "EVENTS",
    TEAM = "TEAM",
    TREASURY = "TREASURY",
}
export enum MAP_TYPE_ICON {
    PLACES = "/assets/img/topos/place-icon.svg",
    EVENTS = "/assets/img/topos/event-icon.svg",
    TEAM = "/assets/img/topos/team-icon.svg",
    TREASURY = "/assets/img/topos/treasury-icon.svg",
}
export enum LAND_FILTER_TYPE {
    LAND = "LAND", 
}
export interface ILandFilter {
    type: LAND_FILTER_TYPE,
    id: ID
}

export type All = IEvent | IPlace | ITeam
 

export type IEventRouteData = {
    path: string,
    elementName: string
}

export const LANDS_FILTER_ICON_URL = "/assets/img/topos/lands.svg"
export const FEED_FILTER_ICON_URL = "/assets/img/topos/news.svg"
export const MY_FEED_FILTER_ICON_URL = "/assets/img/topos/my_feed.svg"

export const LANDS_PAGINATION = ` meta_relation: "AND" metas: [ { key: "hidden", value_bool: false },  { key: "archived", value_bool: false }, { key:"status", value_array: "1,2" } ] `

export enum LANDS_PAGINATION_TYPE {
    DEFAULT,
    MODERATION
}